import { IconButton } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

const BUTTON_VARIANTS = ['primary', 'secondary', 'ghost', 'primary-contrast', 'secondary-contrast', 'overlay', 'destructive']

export const IconButtonExample = {
  title: "IconButton",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [
    {
      name: "variant",
      label: "variant",
      type: "enum",
      tsType: BUTTON_VARIANTS.map((variant) => `"${variant}"`),
      default: "primary",
      options: BUTTON_VARIANTS,
    },
    {
      name: "size",
      label: "size",
      type: "enum",
      tsType: ['"xsmall"', '"small"', '"medium"', '"large"'],
      default: "medium",
      options: ["xsmall", "small", "medium", "large"],
    },
    {
      name: "disabled",
      label: "disabled",
      type: "boolean",
      tsType: "boolean",
      default: false,
    },
    {
      name: "loading",
      label: "loading",
      type: "boolean",
      tsType: "boolean",
      default: false,
    },
    {
      name: "innerClassNames",
      label: "innerClassNames",
      type: "static",
      tsType: "InnerClassNamesProp<IconButtonInnerElementKey>",
      value: "-",
    },
    {
      name: "asChild",
      label: "asChild",
      type: "static",
      tsType: "boolean",
      value: "-",
    },
  ],

  Preview({ props }) {
    return (
      <IconButton
        variant={props.variant}
        aria-label="Название кнопки"
        size={props.size}
        disabled={props.disabled}
        loading={props.loading}
      >
        <PlaceholderIcon />
      </IconButton>
    )
  },

  getCode(props) {
    const lines = []
    if (props.variant !== "primary") lines.push(`  variant="${props.variant}"`)
    if (props.size !== "medium") lines.push(`  size="${props.size}"`)
    if (props.disabled) lines.push(`  disabled`)
    if (props.loading) lines.push(`  loading`)

    const propsStr = lines.length > 0 ? "\n" + lines.join("\n") + "\n" : ""
    return `<IconButton${propsStr}  aria-label="Название кнопки"
>
  <Icon24Placeholder />
</IconButton>`
  },
}